/**
 * == Controller: AiReaderController
 *
 * Manages filters for the analytics/insights dashboard. Persists user
 * selections to cookies, ensures sensible default date ranges, and triggers
 * Turbo Stream refreshes when inputs change.
 *
 * === Responsibilities:
 * - Keep project/date/search filters synchronised between form, cookies, and URL.
 * - Request updated filter parameters and table rows via `fetchAction`.
 * - Support tag removal, bulk clearing, and incremental parameter updates.
 */
import PlatformBaseController from "./platform_base_controller";

// Main controller for handling project/document list filtering
export default class extends PlatformBaseController {
    static targets = [
        "pageUrlForm", "pageUrlInput", "pageUrlSubmit"
    ];

    static values = {
    };

    findPage(event) {
        event.preventDefault();

        const form = event.target.closest("form") || this.pageUrlFormTarget;
        if (!form) return;

        const submitBtn = this.hasPageUrlSubmitTarget ? this.pageUrlSubmitTarget : null;

        const formData = new FormData(form);
        const urlValue = formData.get("url");
        if (typeof urlValue === "string") {
            formData.set("url", urlValue.trim());
        }

        const action = form.getAttribute("action") || "/as_seen_by_ai/ai_reader_find_page";
        const method = form.getAttribute("method") || "post";

        if (submitBtn) submitBtn.disabled = true;

        this.fetchAction(action, {
            method: method,
            body: formData
        }).finally(() => {
            if (submitBtn) submitBtn.disabled = false;
        });
    }
}
